import type {
  AuditKind,
  AuditPreviewPayload,
} from "@/nango/types/apps.autoleads/autoleads/AuditTemplate"

export const auditTemplateKeys = {
  all: ["autoleads", "audit-template"] as const,
  list: (teamId: number | null) =>
    [...auditTemplateKeys.all, "list", teamId] as const,
  preview: (payload: AuditPreviewPayload | null) =>
    [...auditTemplateKeys.all, "preview", payload] as const,
  sampleLeads: (teamId: number | null) =>
    [...auditTemplateKeys.all, "sample-leads", teamId] as const,
  campaign: (campaignId: number | null) =>
    [...auditTemplateKeys.all, "campaign", campaignId] as const,
  leadPdf: (leadId: number, kind: AuditKind) =>
    [...auditTemplateKeys.all, "lead-pdf", leadId, kind] as const,
}
